export default __webpack_public_path__ + "static/media/service_1.46df0d07.jpg";